import { VOICE_BOT_TOOL_TYPES } from './voiceBotSocketConstants';
import { extractGetPageInformationCategory } from './planPageInformation';

const shouldLogVoiceBotWebSocket =
  typeof process !== 'undefined' && process.env.NODE_ENV !== 'production';

const VOICE_BOT_WS_LOG_MAX_STRING = 2500;

export function logVoiceBotWsInbound(message, toolType, parsed) {
  if (!shouldLogVoiceBotWebSocket) return;
  const category =
    toolType === VOICE_BOT_TOOL_TYPES.GET_PAGE_INFORMATION ? extractGetPageInformationCategory(message) : undefined;
  /* eslint-disable no-console -- intentional debug for CES / middleware integration */
  console.log('[VoiceBot WS] inbound (CES → UI)', {
    type: message?.type,
    type_of_request: message?.type_of_request,
    mime_type: message?.mime_type,
    tool_id: message?.tool_id,
    toolType,
    parsed,
    getPageInformationCategory: category,
  });
  console.log('[VoiceBot WS] inbound raw', message);
  /* eslint-enable no-console */
}

export function logVoiceBotWsOutbound(response) {
  if (!shouldLogVoiceBotWebSocket) return;
  let logged = response;
  if (typeof response === 'string' && response.length > VOICE_BOT_WS_LOG_MAX_STRING) {
    logged = `${response.slice(0, VOICE_BOT_WS_LOG_MAX_STRING)}… [truncated, ${response.length} chars total]`;
  }
  /* eslint-disable no-console -- intentional debug for CES / middleware integration */
  console.log('[VoiceBot WS] outbound (UI → CES)', logged === null ? '(null — client may skip send)' : logged);
  /* eslint-enable no-console */
}

export function finishVoiceBotWs(response) {
  logVoiceBotWsOutbound(response);
  return response;
}
